<template>
  <div>
    <el-row :gutter="10">
      <!-- 左侧版块 -->
      <el-col :md="{ span: 24 }" :lg="{ span: isShowRight ? 16 : 24 }">
        <!-- 项目详情开始 -->
        <el-card class="mt-2">
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>{{ formData.prjTitle }}</h6>
              <div>
                <span class="text-muted">
                  {{ $l('label_period') || '项目周期' }}：{{
                    formData.beginDate
                  }}
                  - {{ formData.endDate }}
                </span>
                <b-badge
                  class="ml-2"
                  :variant="
                    formData.prjStatus === 'Y'
                      ? 'success'
                      : formData.prjStatus === 'P'
                      ? 'info'
                      : formData.prjStatus === 'D'
                      ? 'danger'
                      : formData.prjStatus === 'C'
                      ? 'warning'
                      : formData.prjStatus === 'F'
                      ? 'secondary'
                      : formData.prjStatus === 'S'
                      ? 'secondary'
                      : ''
                  "
                >
                  {{
                    formData.prjStatus === 'Y'
                      ? $l('label_completed') || '已完成'
                      : formData.prjStatus === 'P'
                      ? $l('label_in_progress') || '进行中'
                      : formData.prjStatus === 'D'
                      ? $l('label_out_dated') || '已超期'
                      : formData.prjStatus === 'C'
                      ? $l('label_terminated') || '已终止'
                      : formData.prjStatus === 'F'
                      ? $l('label_deleted') || '已删除'
                      : formData.prjStatus === 'S'
                      ? $l('label_draft') || '草稿'
                      : ''
                  }}
                </b-badge>
              </div>
            </b-col>
            <b-col cols="auto">
              <a
                v-b-toggle.collapse-activeProject
                role="button"
                style="color: #606266"
              >
                <i
                  v-if="isActiveProject"
                  class="fa fa-chevron-down"
                  title="收起"
                ></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isActiveProject" id="collapse-activeProject">
            <div class="mt-3">
              <span class="span-color-dark"
                >{{ $l('label_prjMemo') || '项目说明' }}：</span
              >
              <br />
              <p class="text-muted" v-html="formData.prjMemo"></p>
              <p class="text-muted">{{ formData.prjAttribute }}</p>
              <div class="mt-3">
                <span
                  class="span-color-dark"
                  v-if="
                    formData.prjStatus === 'Y' || formData.prjStatus === 'C'
                  "
                >
                  {{ $l('label_complete_comform') || '项目结束确认' }}：
                </span>
              </div>
              <p
                class="text-muted"
                v-if="formData.prjStatus === 'Y' || formData.prjStatus === 'C'"
              >
                {{ formData.completeDesc }}
              </p>
              <b-row>
                <b-col cols="4">
                  <span class="span-color-dark"
                    >{{ $l('label_prjCategoryCode') || '项目类型' }}：</span
                  >
                  <br />
                  <span class="text-muted">{{ formData.prjCategoryName }}</span>
                </b-col>
                <b-col cols="4">
                  <span class="span-color-dark"
                    >{{ $l('label_projectType') || '项目角色' }}：</span
                  >
                  <br />
                  <span class="text-muted">{{ formData.projectTypeName }}</span>
                </b-col>
                <b-col cols="4">
                  <span class="span-color-dark"
                    >{{ $l('label_masterCategoryCode') || '产品类别' }}：</span
                  >
                  <br />
                  <span class="text-muted">{{
                    formData.masterCategoryCodeName
                  }}</span>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="4">
                  <span class="span-color-dark"
                    >{{ $l('label_search_customer') || '项目客户' }}：</span
                  >
                  <br />
                  <span class="text-muted">{{ formData.custName }}</span>
                </b-col>
                <b-col cols="8">
                  <span class="span-color-dark"
                    >{{ $l('label_proofing') || '打样信息' }}：</span
                  >
                  <br />
                  <span class="text-muted">
                    {{
                      formData.sampleType === 'N'
                        ? $l('option_sampleType_1') || '无需打样'
                        : formData.sampleType === 'S'
                        ? $l('option_sampleType_2') || '样品打样'
                        : formData.sampleType === 'M'
                        ? $l('option_sampleType_3') || '面料打样'
                        : ''
                    }}
                    <el-divider
                      direction="vertical"
                      v-if="formData.sampleType !== 'N'"
                    ></el-divider>
                    <span class="text-muted" v-if="formData.sampleType !== 'N'"
                      >{{ $l('label_sampleNo') || '打样产品编号' }}：{{
                        formData.sampleNo
                      }}</span
                    >
                  </span>
                  <br />
                  <span class="text-muted" v-if="formData.sampleType !== 'N'"
                    >{{ $l('label_supCode') || '打样工厂' }}：{{
                      formData.supName
                    }}</span
                  >
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="4">
                  <span class="span-color-dark"
                    >{{ $l('label_prjOwnerCode') || '项目负责人' }}：</span
                  >
                  <b-avatar-group size="3rem" overlap="0.15" class="mt-2">
                    <b-avatar
                      :src="formData.prjOwnerImgUrl"
                      v-b-tooltip.hover
                      :title="formData.prjOwnerCodeName"
                    ></b-avatar>
                  </b-avatar-group>
                </b-col>
                <b-col cols="8">
                  <span class="span-color-dark"
                    >{{ $l('label_prjParticipant') || '项目成员' }}：</span
                  >
                  <b-avatar-group size="3rem" overlap="0.15" class="mt-2">
                    <b-avatar
                      v-for="(item, index) in formData.teamPhotoList"
                      :key="index"
                      :src="item.memberImgUrl"
                      v-b-tooltip.hover
                      :title="item.memberUserName"
                    ></b-avatar>
                  </b-avatar-group>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="refresh"
                    variant="outline-secondary"
                    >{{ $l('btn_refresh') || '刷新项目' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="editProject('edit', formData.prjCode)"
                    variant="outline-dark"
                    v-if="
                      formData.isPrjOwner === 'Y' &&
                        formData.prjStatus !== 'Y' &&
                        formData.prjStatus !== 'C' &&
                        formData.prjStatus !== 'F'
                    "
                    >{{ $l('btn_edit') || '编辑项目' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="copyProject()"
                    variant="outline-success"
                  >
                    {{ $l('btn_copy') || '复制项目' }}
                  </b-button>
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="createSubProject"
                    variant="outline-success"
                    v-if="
                      formData.prjStatus === 'P' || formData.prjStatus === 'D'
                    "
                    >{{ $l('btn_create_sub') || '创建子项目' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="questionShow('F')"
                    variant="outline-danger"
                    v-if="
                      formData.isPrjOwner === 'Y' && formData.prjStatus === 'S'
                    "
                    >{{ $l('btn_delete') || '删除项目' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="completeProject('complete', 'Y')"
                    variant="outline-primary"
                    v-if="
                      formData.isPrjOwner === 'Y' &&
                        formData.prjStatus !== 'Y' &&
                        (formData.prjStatus === 'P' ||
                          formData.prjStatus === 'D')
                    "
                    >{{ $l('btn_complete') || '项目完成' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="completeProject('stop', 'C')"
                    variant="outline-danger"
                    v-if="
                      formData.isPrjOwner === 'Y' &&
                        formData.prjStatus !== 'Y' &&
                        (formData.prjStatus === 'P' ||
                          formData.prjStatus === 'D')
                    "
                    >{{ $l('btn_stop') || '终止项目' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="questionShow('P')"
                    variant="outline-info"
                    v-if="
                      formData.isPrjOwner === 'Y' &&
                        formData.prjStatus !== 'Y' &&
                        formData.prjStatus === 'C'
                    "
                    >{{ $l('btn_reprocess') || '恢复执行' }}</b-button
                  >
                  <b-button
                    class="mr-2"
                    size="sm"
                    @click="projectMapShow"
                    variant="outline-info"
                    >{{ $l('btn_project_map') || '项目地图' }}</b-button
                  >
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col class="d-flex flex-row flex-wrap">
                  <b-form-checkbox
                    v-model="isShowSubProjects"
                    switch
                    class="mr-3 span-color-dark"
                    >{{
                      $l('checkbox_show_subprojects') || '显示子项目'
                    }}</b-form-checkbox
                  >
                  <b-form-checkbox
                    v-model="isShowComments"
                    switch
                    class="mr-3 span-color-dark"
                    >{{
                      $l('checkbox_show_comments') || '显示沟通信息'
                    }}</b-form-checkbox
                  >
                  <b-form-checkbox
                    v-model="isShowProducts"
                    switch
                    class="mr-3 span-color-dark"
                    >{{
                      $l('checkbox_show_products') || '显示选品记录'
                    }}</b-form-checkbox
                  >
                  <b-form-checkbox
                    v-model="isShowRight"
                    switch
                    class="mr-3 span-color-dark"
                    >{{
                      $l('checkbox_show_right') || '显示里程碑和项目文件'
                    }}</b-form-checkbox
                  >
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </el-card>
        <!-- 子项目列表开始 -->
        <el-card class="mt-2" v-if="isShowSubProjects">
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>{{ $l('card_subproject_title') || '子项目列表' }}</h6>
            </b-col>
            <b-col cols="auto">
              <a
                v-b-toggle.collapse-subProject
                role="button"
                style="color: #606266"
              >
                <i
                  v-if="isSubProject"
                  class="fa fa-chevron-down"
                  title="收起"
                ></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isSubProject" id="collapse-subProject">
            <subproject
              ref="subproject"
              :params="subProjectParams"
              :autoLoad="true"
            ></subproject>
          </b-collapse>
        </el-card>
        <!-- 项目沟通开始 -->
        <el-card class="mt-2" v-if="isShowComments">
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>{{ $l('card_comments_title') || '项目沟通' }}</h6>
            </b-col>
            <b-col cols="auto">
              <a
                v-b-toggle.collapse-communicateProject
                role="button"
                style="color: #606266"
              >
                <i
                  v-if="isCommunicateProject"
                  class="fa fa-chevron-down"
                  title="收起"
                ></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse
            v-model="isCommunicateProject"
            id="collapse-communicateProject"
          >
            <comments
              ref="comments"
              :params="commentsParams"
              :autoLoad="true"
              @refresh="refresh"
            ></comments>
          </b-collapse>
        </el-card>
        <!-- 项目选品池 -->
        <el-card class="mt-2" v-if="isShowProducts">
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>{{ $l('card_product_title') || '项目选品' }}</h6>
            </b-col>
            <b-col cols="auto">
              <a
                v-b-toggle.collapse-product
                role="button"
                style="color: #606266"
              >
                <i
                  v-if="isProducts"
                  class="fa fa-chevron-down"
                  title="收起"
                ></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isProducts" id="collapse-product">
            <Products
              ref="product"
              :params="productParams"
              :autoLoad="true"
            ></Products>
          </b-collapse>
        </el-card>
      </el-col>
      <!-- 右侧版块开始 -->
      <el-col
        class="mt-2"
        :md="{ span: 24 }"
        :lg="{ span: 8 }"
        v-if="isShowRight"
      >
        <!-- 项目里程碑开始 -->
        <el-card>
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>{{ $l('card_milestone_title') || '项目里程碑' }}</h6>
            </b-col>
            <b-col cols="auto">
              <a
                v-b-toggle.collapse-milepostProject
                role="button"
                style="color: #606266"
              >
                <i
                  v-if="isMilepostProject"
                  class="fa fa-chevron-down"
                  title="收起"
                ></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isMilepostProject" id="collapse-milepostProject">
            <p></p>
            <milestone
              ref="milestone"
              :params="formData"
              :autoLoad="true"
            ></milestone>
          </b-collapse>
        </el-card>
        <!-- 项目文件开始 -->
        <el-card class="mt-2">
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <h6>{{ $l('card_file_title') || '项目文件' }}</h6>
            </b-col>
            <b-col cols="auto">
              <a
                v-b-toggle.collapse-fileProject
                role="button"
                style="color: #606266"
              >
                <i
                  v-if="isFileProject"
                  class="fa fa-chevron-down"
                  title="收起"
                ></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse v-model="isFileProject" id="collapse-fileProject">
            <p></p>
            <project-doc
              ref="docs"
              :params="docsParams"
              :autoLoad="true"
              @refreshComments="refreshComments"
            ></project-doc>
          </b-collapse>
        </el-card>
      </el-col>
    </el-row>
    <!-- 项目完成或终止确认弹框 -->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="600px"
    >
      <page-detail
        ref="form"
        :prjCode="formData.prjCode"
        @success="saveSuccess"
      ></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l('btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >{{ $l('btn_save') || '保存' }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 按钮操作提示确认弹框 -->
    <el-dialog
      :title="$l('tips_question_title') || '提示信息'"
      :visible.sync="questionDialogVisible"
      width="30%"
    >
      <span>{{ question }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionDialogVisible = false" size="small">{{
          $l('btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" @click="updateProjectStatus()" size="small">{{
          $l('btn_confirm') || '确认'
        }}</el-button>
      </span>
    </el-dialog>
    <add-sub-project ref="addSubProject" />
    <el-dialog
      custom-class="prject_map_dialog"
      :visible.sync="projectMapDialogVisible"
      width="60%"
      @open="projectMapDialogOpened"
    >
      <ProjectMap ref="projectMap" :prjCode="formData.prjCode" />
    </el-dialog>
  </div>
</template>
<script>
import addSubProject from '@/views/digital/projectManager/info/components/add'
import ProjectMap from '@/views/digital/components/projectmap'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {
    PageDetail: () => import('./components/complete/index'),
    Milestone: () => import('./components/milestone/index'),
    Subproject: () => import('./components/subproject/index'),
    addSubProject,
    Comments: () => import('./components/comments/index'),
    ProjectDoc: () => import('./components/projectdoc/index'),
    Products: () => import('./components/products/index'),
    ProjectMap,
  },
  data() {
    return {
      question: '',
      questionDialogVisible: false,
      projectMapDialogVisible: false,
      updateStatus: '',
      mainProps: { width: 40, height: 40 },
      max: 100,
      isActiveProject: true, // 活动项目折叠状态
      isSubProject: true, // 子项目折叠状态
      isCommunicateProject: true, // 项目沟通折叠状态
      isMilepostProject: true, // 项目里程碑折叠状态
      isFileProject: true, // 项目文件折叠状态
      isProducts: true, // 项目文件折叠状态
      isBusy: false,
      isShowSubProjects: true,
      isShowComments: true,
      isShowProducts: true,
      isShowRight: true,
      page: {
        curPage: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      formData: {
        prjCode: '',
        prjNo: '',
        prjTitle: '',
        prjCategoryCode: '',
        masterCategoryCode: '',
        categoryCode: '',
        custCode: '',
        custName: '',
        prjOwnerCode: '',
        beginDate: '',
        endDate: '',
        sampleType: '',
        sampleNo: '',
        supCode: '',
        linkPrjCode: '',
        prjMemo: '',
        prjStatus: 'Y',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
        completeDesc: '',
      },
      tabVisible: {
        scheduleAndParticipant: true,
        product: true,
        customerRecommend: true,
        quotation: true,
        prjSample: true,
        material: true,
        feedback: false,
      },
      curParam: {
        prjCode: '',
      },
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
    }
  },
  // 侦听器
  watch: {
    '$route.params'() {
      if (this.$route.params.prjCode && this.$route.params.pageType) {
        this.isShowSubProjects = true
        this.isShowComments = true
        this.isShowProducts = true
        this.isShowRight = true
        this.formLoad()
      }
    },
  },
  mounted() {
    this.formLoad()
  },
  computed: {
    // 根据打样类型控制tab显隐
    visible() {
      if (this.formData.sampleType === 'N') {
        return { ...this.tabVisible, prjSample: false, material: false }
      } else if (this.formData.sampleType === 'S') {
        return {
          ...this.tabVisible,
          product: false,
          customerRecommend: false,
          quotation: false,
          material: false,
        }
      } else if (this.formData.sampleType === 'M') {
        return {
          ...this.tabVisible,
          product: false,
          customerRecommend: false,
          quotation: false,
          prjSample: false,
        }
      }
      return {}
    },
    attrParams() {
      return {
        infoCode: this.formData.prjCode,
        templateCategoryCode: this.formData.prjCategoryCode,
        masterCategoryCode: this.formData.masterCategoryCode,
        templateType: 'P',
      }
    },
    prjParams() {
      return {
        prjCode: this.formData.prjCode,
        prjCategoryCode: this.formData.prjCategoryCode,
        masterCategoryCode: this.formData.masterCategoryCode,
      }
    },
    subProjectParams() {
      return {
        prjCode: this.formData.prjCode,
      }
    },
    addSubProjectParams() {
      return {
        linkPrjCode: this.formData.prjCode,
        custCode: this.formData.custCode,
        topPrjCode: this.formData.topPrjCode,
        formTitle: this.$l('INDEX.label_title_add_subproject') || '新增子项目',
      }
    },
    commentsParams() {
      return {
        prjCode: this.formData.prjCode,
      }
    },
    docsParams() {
      return {
        prjCode: this.formData.prjCode,
      }
    },
    productParams() {
      return {
        prjCode: this.formData.prjCode,
      }
    },
  },
  methods: {
    formLoad() {
      let prjCode = this.$route.params.prjCode
      this.curParam.prjCode = prjCode
      this.refresh()
    },
    refresh() {
      // 刷新界面
      this.$api.projectInfoViewDetailApi(this.curParam).then((res) => {
        this.formData = res.body
        if (this.formData.prjMemo !== null) {
          // 替换项目说明中的空格
          this.formData.prjMemo = this.formData.prjMemo
            .replace(/ /g, '&nbsp;')
            .replace(/\n/g, '<br/>')
        }

        this.curParam.prjCode = this.formData.prjCode
        this.subProjectParams.prjCode = this.formData.prjCode
        this.commentsParams.prjCode = this.formData.prjCode
        this.docsParams.prjCode = this.formData.prjCode
        this.productParams.prjCode = this.formData.prjCode
      })
    },
    // goBack() {
    //   this.$router.go(-1)
    // },
    // 编辑项目
    editProject(ref, val = '') {
      this.$router.push({
        name: 'projectManagement-projectInfo-edit',
        params: {
          pageType: ref,
          prjCode: val,
        },
      })
    },
    // 建立子项目
    createSubProject() {
      this.$refs.addSubProject.fromLoad('addsub', this.addSubProjectParams)
    },
    questionShow(val) {
      if (val === '') {
        return
      }
      this.updateStatus = val
      if (val === 'F') {
        this.question = this.$l('tips_question_delete') || '是否要删除当前项目?'
      } else if (val === 'P') {
        this.question =
          this.$l('tips_question_reprocess') || '是否要重新启用当前项目?'
      } else {
        this.question = this.$l('tips_question_save') || '是否要保存更改?'
      }
      this.questionDialogVisible = true
    },
    projectMapShow() {
      this.projectMapDialogVisible = true
    },
    projectMapDialogOpened() {
      this.$nextTick(() => {
        this.$refs.projectMap.init()
      })
    },
    updateProjectStatus() {
      if (this.updateStatus === '') {
        return
      }
      this.formData.prjStatus = this.updateStatus
      this.$api.projectInfoUpdateStatusApi(this.formData).then((res) => {
        this.$message({
          showClose: true,
          message: this.$l('tips_save_ok') || '保存成功！',
          type: 'success',
        })
      })
      this.questionDialogVisible = false
    },
    completeProject(ref, val) {
      const opt = {
        complete: this.$l('tips_complete_title') || '完成确认',
        stop: this.$l('tips_stop_title') || '终止确认',
      }
      // 设置标题
      this.formOption.title = opt[ref]
      this.formOption.dialogSaveBtnVisible = true
      // 显示表单
      this.formOption.dialogFormVisible = true
      let isdelay = false
      if (ref === 'complete') {
        const now = Date.now()
        const endTime = new Date(this.formData.endDate).getTime()
        if (now > endTime) {
          isdelay = true
        }
      }
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, { status: val, isdelay })
      }, 0)
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.formLoad()
      this.cancel()
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    },
    refreshComments() {
      this.$refs.comments.init(this.commentsParams)
    },
    async copyProject() {
      const { prjCode } = this.formData
      if (!prjCode) return

      const confirm = await this.$confirm(
        this.$l('tips_copyPrj') || '是否要复制该项目？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .projectInfoCopyApi({ prjCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_copy_error') || '复制失败！')
        return
      }

      this.$router.push({
        name: 'projectManagement-projectInfo-edit',
        params: {
          pageType: 'edit',
          prjCode: body,
        },
      })
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.projectMapDialogVisible = false
    next()
  },
}
</script>
<style lang="scss">
.prject_map_dialog {
  height: 70%;
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      z-index: 9999;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
}
.hidden-header {
  display: none;
}
.file-row-style {
  border-radius: 5px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
}
.file-badge-style {
  width: 50px;
  height: 50px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.span-color-dark {
  color: #6c757d !important;
  font-size: 0.9375rem;
  font-weight: 500;
}
.text-muted {
  font-size: 14px;
  color: #6c757d !important;
}
</style>
